<template>
  <ul class="flex items-center text-[10px] text-white/50 justify-between mt-3 gap-4">
    <li
      v-for="(item, index) in shareList"
      :key="`${item.title}-${index}`"
      @click="handleShare(item.link)"
      class="flex items-center gap-1 flex-col flex-1"
    >
      <a :href="item.link" class="text-center">
        <Image :src="item.icon" :alt="item.title" class="w-7 h-7" />
        <span class="text-white/50">{{ item.title }}</span>
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import facebook33 from "./images/facebook33.png";
import whatsapp33 from "./images/whatsapp33.png";
import telegram33 from "./images/telegram33.png";
import insgram33 from "./images/insgram33.png";
import twitter33 from "./images/twitter33.png";
import kwai33 from "./images/kwai33.png";
import { isAndroid } from "@/env";
import { copyText } from "@/utils";
import { useGetDomain } from "@/hooks/useGetDomain";
import { getTreasureboxShareConfig } from "@/api/treasurebox";
const props = defineProps({
  noActivity: {
    // 是否不包含活动id
    type: Boolean,
    default: false,
  },
  textType: {
    // 文本类型   treasurebox 宝箱
    type: String,
    default: "domain",
  },
});
const { domain } = useGetDomain(props.noActivity);

// const handleHost = (host: string) => {
//   return host?.startsWith("www") ? host?.slice(4) : host;
// };
const text = ref<any>("");

const newFacebookShareLink = computed(
  () =>
    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      domain.value
    )}&quote=${encodeURIComponent(text.value)}`
);

const shareList = computed(() => [
  {
    title: "Facebook",
    icon: facebook33,
    link: isAndroid ? newFacebookShareLink.value : `fb://share/?link=${domain.value}`,
  },
  {
    title: "WhatsApp",
    icon: whatsapp33,
    link: `whatsapp://send?text=${encodeURIComponent(text.value + " " + domain.value)}`,
  },
  {
    title: "Telegram",
    icon: telegram33,
    link: `https://t.me/share/url?url=${encodeURIComponent(
      text.value + " " + domain.value
    )}`,
  },
  {
    title: "Instagram",
    icon: insgram33,
    link: isAndroid
      ? `https://www.instagram.com/?quote=${encodeURIComponent(
          text.value + " " + domain.value
        )}`
      : `instagram:/?quote?text=${encodeURIComponent(text.value + " " + domain.value)}`,
  },
  {
    title: "Twitter",
    icon: twitter33,
    link: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      text.value + " " + domain.value
    )}`,
  },
  {
    title: "Kwai",
    icon: kwai33,
    link: isAndroid
      ? "intent://launch#Intent;scheme=kwai;package=com.kwai.video;end"
      : `https://www.kwai.com?content=${encodeURIComponent(
          text.value + " " + domain.value
        )}`,
  },
]);

const handleShare = (link: string) => {
  copyText(text.value + " " + domain.value);
};

const getTreasureboxShareConfigData = async () => {
  const res = await getTreasureboxShareConfig();
  if (res.code === 1) {
    text.value = res.data.shareText;
  }
};
onMounted(() => {
  getTreasureboxShareConfigData();
});
</script>

<style lang="scss" scoped></style>
